

export default (opts = {}) => {
  const component = {
    model: {
      
      defaults: {
        type:'link', 
        name:'Botão',
        traits: [
          {
            type:'id',
            name:'id',
            Label:'id',
          },
        ],
        components:[
          {
            type:'link',
            style: {
              'min-width': '250px',
              'font-size':'16px',
              'color':'#000',
              'padding':'10px', 
              'border': '1px solid #747474', 
              'text-align': 'center', 
              'display':'block',
              'text-transform': 'uppercase',
              'text-decoration': 'none'
            },
            components: [
              {
                type:'text',
                content: 'Lorem Ipsum',
            },
            ],
          },
        ],
        styles: `
        *{
          font-family: Roboto, Arial, sans-serif;
        }
       `,
      },
    },
    view: {

    },
  };

  return component;
};
